<template>
  <div class="e-study">
    <TopNav :current="current" :lessonInfo="lessonInfo"/>
    <leftNav :downloads="downloads" :current="current" @changeCurrent="changeCurrent" :chapters="chapters" @switchToVideo="state = 'video'" @switchToTopic="switchToTopic"/>
    <div v-show="state == 'video'" class="e-study-video">
      <VideoPlayer
        :current="current"
        :chapters="chapters"
        :currentChapterIndex="currentChapterIndex"
        :currentSegmentIndex="currentSegmentIndex"
        @updateProgress="updateProgress"
        @next="nextSegment"/>
    </div>
    <div v-show="state == 'topic'" class="e-study-topic">
      <Topic :current="current" @finishExstatus="finishExstatus"/>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '../../components/study/video'
import TopNav from '../../components/study/top-nav'
import Topic from '../../components/study/topic'
import leftNav from '../../components/study/left-nav'

import api from '@/api/index'

export default {
  components: {
    VideoPlayer,
    TopNav,
    leftNav,
    Topic,
  },
  data () {
    return {
      state: 'video',
      // host: hostConfig.host,
      chapters: [],
      current: null,
      currentChapterIndex: null,
      currentSegmentIndex: null,
      lessonInfo: null,
      downloads: null
    }
  },
  methods: {
    updateProgress () {
      this.$set(this.current, 'lostatus', 1)
    },
    switchToTopic (chapter, chapterIndex) {
      this.state = 'topic'
      if (this.current && this.current.videourl) {
        let segment = this.chapters[this.currentChapterIndex].listdata[this.currentSegmentIndex]
        segment.isCurrent = false
        this.$set(this.chapters[this.currentChapterIndex].listdata, this.currentSegmentIndex, segment)
      }
      this.currentChapterIndex = chapterIndex
      this.currentSegmentIndex = null
      this.current = {
        chapterIndex: chapterIndex,
        type: 'topics',
        exstatus: this.chapters[chapterIndex].exstatus
      }
    },
    changeCurrent (segment, segmentIndex, chapter, chapterIndex) {
      if (this.current) {
        this.current.isCurrent = false
      }
      segment.isCurrent = true
      if (segment.videourl) {
        this.state = 'video'
      } else {
        this.state = 'topic'
      }
      this.currentChapterIndex = chapterIndex
      this.currentSegmentIndex = segmentIndex
      this.current = segment
      this.$set(this.chapters[chapterIndex].listdata, segmentIndex, segment)
    },
    nextSegment () {
      let chapterIndex = this.currentChapterIndex
      let nextSegmentIndex = this.currentSegmentIndex + 1
      let chapter = this.chapters[chapterIndex]
      let nextSegment = chapter.listdata[nextSegmentIndex]
      if (chapter) {
        if (nextSegment) {
          this.changeCurrent(nextSegment, nextSegmentIndex, chapter, chapterIndex)
        } else {
          if (chapter.onstatus === 0) {
            chapterIndex = chapterIndex + 1
            chapter = this.chapters[chapterIndex]
            nextSegmentIndex = 0
            nextSegment = chapter.listdata[nextSegmentIndex]
            this.changeCurrent(nextSegment, nextSegmentIndex, chapter, chapterIndex)
          } else {
            this.switchToTopic(chapter, chapterIndex)
          }
        }
      } else {
        throw new Error('已经是最后一节课了')
      }
    },
    finishExstatus () {
      this.chapters[this.currentChapterIndex].exstatus = 1
    }
  },
  async mounted () {
    // 获取课程列表
    try {
      let response;
      // ${this.$route.params.id}
      response = await api.getPreshowData(this.$route.params.id)
      for (let chapter of response.data.coulist) {
        for (let segment of chapter.listdata) {
          segment.isCurrent = false
        }
      }
      this.chapters = response.data.coulist
      this.lessonInfo = response.data.mallinfo
      this.downloads = response.data.downs
    } catch (e) {
      throw new Error(`出错了，凶手是${e}`);
    }
    // 获取章节信息
    let currentChapterIndex = parseInt(this.$route.params.chapterid)
    let currentSegmentIndex = parseInt(this.$route.params.segmentid)
    // 如果只有章没有节 就去做题
    if (Number.isInteger(currentChapterIndex) && !Number.isInteger(currentSegmentIndex)){
      // 如果发现没有题 就去本章第一节
      if (this.chapters[currentChapterIndex].onstatus) {
        this.switchToTopic(this.chapters[currentChapterIndex], currentChapterIndex)
        return
      } else {
        currentSegmentIndex = 0
      }
    }

    if (!currentChapterIndex && !currentSegmentIndex) {
      currentChapterIndex = 0
      currentSegmentIndex = 0
    }

    // 获取当前课程
    if (Number.isInteger(currentChapterIndex) && Number.isInteger(currentSegmentIndex)) {
      this.currentChapterIndex = currentChapterIndex
      this.currentSegmentIndex = currentSegmentIndex
      let currentSegment = this.chapters[this.currentChapterIndex].listdata[this.currentSegmentIndex]
      currentSegment.isCurrent = true
      this.current = currentSegment
    }
  },
  watch: {
    async current (val) {
      if (val.chapterorder && val.listorder) {
        await api.updateRecentlyStudied(this.$route.params.id, val.chapterorder, val.listorder)
      }
    }
  }
}
</script>

<style lang="scss">
  .e-study{
    position: fixed;
    width: 100%;
    height: 100%;
    .e-study-video{
      width: 100%;
      padding-left: 65px;
      background-color: #ccc;
      box-sizing: border-box;
      position: absolute;
      top: 0px;
      padding-top: 55px;
      height: 100%;
      justify-content: center;
      align-items: center;
      display: flex;
    }
    .e-study-topic{
      box-sizing: border-box;
      padding-top: 135px;
      padding-left: 65px;
      height: 100%;
      overflow: scroll;
    }
  }
</style>
